'use strict';

var version = require('../version.json');

/**
 * A context creator for sdk
 *
 * @return {Object}   The context sdk to be attached to an event
 */
function sdk() {
  return {
    name: 'context_sdk',
    data: { version_name: version.version }
  };
}

module.exports = sdk;
